// Import external
import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({

    selector: 'syn-create-group-dialog',
    templateUrl: 'create-group-dialog.component.html'
})
export class CreateGroupDialogComponent {

    public groupFormControl: FormControl;

    public readonly MIN_GROUP_LENGTH = 3;
    public readonly MAX_GROUP_LENGTH = 50;
    private readonly GROUP_PATTERN = /^[a-zA-Z0-9].*[a-zA-Z0-9]$/;

    constructor(
        private matDialogRef: MatDialogRef<CreateGroupDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.groupFormControl = new FormControl(
            data.name,
            Validators.compose([
                Validators.pattern(this.GROUP_PATTERN),
                Validators.minLength(this.MIN_GROUP_LENGTH),
                Validators.maxLength(this.MAX_GROUP_LENGTH),
                Validators.required
            ]));
    }

    public confirm(): void {
        this.matDialogRef.close({
            status: true,
            group: this.groupFormControl.value
        });
    }

    public cancel(): void {
        this.matDialogRef.close({
            status: false
        });
    }
}
